<template>
	<nav
		aria-label="Fil d'Ariane"
		class="breadcrumb"
	>
		<ol class="list-style-none d-flex align-center breadcrumb__list">
			<li
				v-for="(item, index) in itemsToDisplay"
				:key="index"
				class="d-flex align-center breadcrumb__item"
			>
				<AmeliproBtn
					class="text-none font-weight-semibold breadcrumb__btn"
					hover-underline
					:href="item.href"
					text
					:to="item.to"
					@click="emitClickEvent(item.id)"
				>
					{{ item.title }}
				</AmeliproBtn>

				<span
					aria-hidden="true"
					class="breadcrumb__separator"
				/>
			</li>

			<li>
				<p
					aria-current="page"
					class="text-none mb-0 breadcrumb__active-page"
				>
					{{ items[items.length - 1].title }}
				</p>
			</li>
		</ol>
	</nav>
</template>

<script setup lang="ts">
	import { PropType, computed } from 'vue';
	import { AmeliproBreadcrumbItem } from './types';
	import AmeliproBtn from '../AmeliproBtn/AmeliproBtn.vue';
	import BreakpointHelper from '../../helpers/BreakpointHelper';

	const props = defineProps({
		items: {
			type: Array as PropType<AmeliproBreadcrumbItem[]>,
			required: true,
		},
	});
	const breakpointHelper = new BreakpointHelper();

	const itemsToDisplay = computed<AmeliproBreadcrumbItem[]>(() => {
		let itemsList = props.items.slice(0, (props.items.length - 1));

		if (breakpointHelper.is('xsOnly')) {
			itemsList = [props.items[props.items.length - 2]];
		}

		return itemsList;
	});

	const emit = defineEmits(['click']);
	const emitClickEvent = (id: string): void => {
		emit('click', id);
	};
</script>

<style lang="scss" scoped>
.breadcrumb__separator {
	display: block;
	width: 0;
	height: 1.25rem;
	margin: 0 0.5rem;
	border-left: 1px solid $ap-grey-darken1;
}
</style>
